import { TransactionErrorType } from './TransactionErrorType'

export class TransactionError extends Error {
  public type: TransactionErrorType

  constructor(type: TransactionErrorType, options?: { cause?: unknown }) {
    super(type)

    this.type = type
    this.name = 'TransactionError'
    if (options?.cause !== undefined) {
      const self = this as Error & { cause?: unknown }
      self.cause = options.cause
    }
  }
}
